export enum EPasswordStrength {
  WEAK = "weak",
  MEDIUM = "medium",
  STRONG = "strong",
}

export interface IPasswordStrength {
  level: EPasswordStrength;
  // NOTE: whether the password passes `passwordSchema`. The meter is advisory;
  // the schema stays the only gate, so a weak password that still meets the
  // policy is submittable and the UI has to say so.
  isPolicyMet: boolean;
}

export interface IGetPasswordStrengthProps {
  password: string;
}
